import { Component, OnInit } from '@angular/core';
import { AgentState } from '../core/store/agent/agent.state';
import { Select, Store } from '@ngxs/store';
import { Observable, combineLatest } from 'rxjs';
import { ApiStoreData, CcsSentryError } from '../core/store/utils';
import { ApiSearchUsersResponse, ApiSignInAgentWithOtpResponse } from '../core/models';
import { Router } from '@angular/router';
import { Gtag } from 'angular-gtag';

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss'],
})
export class AgentsComponent implements OnInit {
  @Select(AgentState.signInAgentWithOtpState) signInAgentWithOtpState$!: Observable<
    ApiStoreData<ApiSignInAgentWithOtpResponse | null>
  >;
  @Select(AgentState.searchUsersState) searchUsersState$!: Observable<ApiStoreData<ApiSearchUsersResponse | null>>;

  signInAgentIsLoading: boolean = false;
  searchUsersIsLoading: boolean = false;
  errors: CcsSentryError[] | null = null;

  constructor(private gtag: Gtag, private router: Router, private store: Store) {}

  ngOnInit() {
    combineLatest([this.signInAgentWithOtpState$, this.searchUsersState$]).subscribe(
      ([signInAgentWithOtpState, searchUsersState]) => {
        this.signInAgentIsLoading = signInAgentWithOtpState.isLoading;
        this.searchUsersIsLoading = searchUsersState.isLoading;
        if (signInAgentWithOtpState.error || searchUsersState.error) {
          this.errors = [signInAgentWithOtpState.error, searchUsersState.error].filter((e) => !!e) as CcsSentryError[];
          this.gtag.event('agent_login_error', {
            event_category: 'engagement',
          });
        } else {
          this.errors = null;
          if (signInAgentWithOtpState.data && searchUsersState.data) {
            this.gtag.event('agent_login_success', {
              event_category: 'engagement',
            });
            this.router.navigate(['/']);
          }
        }
      }
    );
  }
}
